import { joiResolver } from "@hookform/resolvers/joi";
import { Button, TextField } from "@mui/material";
import Joi from "joi";
import { get } from "lodash";
import React, { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useMutation } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { addNewBoard } from "../../services/subjects";
import { setModalState } from "../../store/modal/modalSlice";
import BaseModal from "../BaseModal";

export default function AddBoard({ refetch }) {
  const dispatch = useDispatch();

  const { open: isOpen, id: subject_id } = useSelector((state) =>
    get(state.modal, "modal.addBoard")
  );

  const schema = Joi.object({
    name: Joi.string().required(),
    subject_id: Joi.string().required(),
  });

  useEffect(() => {
    setValue("subject_id", subject_id, {});
  }, [subject_id]);

  const defaultState = {
    name: "",
  };

  const { control, handleSubmit, reset, setValue } = useForm({
    defaultValues: defaultState,
    resolver: joiResolver(schema),
  });

  const { mutateAsync: addBoardMutation } = useMutation(addNewBoard);

  const onSubmit = async ({ name, subject_id }) => {
    await addBoardMutation(
      { name, subject_id },
      {
        onError: (error) => {
          toast.error(error.message);
        },
        onSuccess: (data) => {
          dispatch(
            setModalState({
              modal: "modal.addBoard",
              state: { open: false, refetch: true },
            })
          );
          reset();
        },
      }
    );
  };

  const handleClose = () => {
    dispatch(
      setModalState({
        modal: "modal.addBoard",
        state: { open: false, refetch: false },
      })
    );
  };

  return (
    <BaseModal
      isOpen={isOpen}
      onClose={handleClose}
      heading="Add New Board"
      footerChildren={
        <Button onClick={handleSubmit(onSubmit)}>Add Board</Button>
      }
    >
      <Controller
        name="name"
        control={control}
        render={({ field, fieldState }) => (
          <TextField
            label="Enter Board Name"
            size="small"
            error={!!fieldState.error}
            {...field}
          />
        )}
      />
    </BaseModal>
  );
}
